import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=90fb3b8e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=90fb3b8e&prod&lang=css"
import style1 from "./detail.vue?vue&type=style&index=1&id=90fb3b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fb3b8e",
  null
  
)

export default component.exports